import { render, staticRenderFns } from "./TeachersPxBot.vue?vue&type=template&id=d9e06390&scoped=true&"
import script from "./TeachersPxBot.vue?vue&type=script&lang=js&"
export * from "./TeachersPxBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e06390",
  null
  
)

export default component.exports